import React from 'react';
import { IActivityBatchEditingTableProps } from './IActivityBatchEditingTableProps';
import { ActivityExecutionService } from '@services/actions/ActivityExecutionService';
import { BatchEditingTableModal } from '@organisms/actions/BatchEditingTableModal/BatchEditingTableModal';

export const ActivityBatchEditingTableModal: React.FC<IActivityBatchEditingTableProps> = (
    props: IActivityBatchEditingTableProps,
) => {
    const service = new ActivityExecutionService();

    return (
        <BatchEditingTableModal
            source={{
                getScheme: () => service.getBatchEditingTableScheme(props.actionKey, props.actId),
                getData: () => service.getBatchEditingTableData(props.actionKey, props.actId, props.docId),
                save: (values) => service.saveBatchEditingTableData(props.actId, props.docId, props.actionKey, values),
            }}
            contentClassName="activity-batch-editing-table-content"
            title={props.title}
            okButtonText={props.okButtonText}
            cancelButtonText={props.cancelButtonText}
            modalSize={props.modalSize}
            completeHandler={props.completeHandler}
        />
    );
};
